module.exports = __webpack_public_path__ + "img/icon-store-competitor-product.4789b5f7.svg";